// TIP: Consider writing a script to generate
// your type definitions using server-declared types
// instead of coding this by hand.
// For example, if your API is using C#, you could
// use C#'s reflection to read your C#
// types and generate this .js file. This way, you
// don't have to manually keep your client and server
// types in sync. 👍
import { shape, number, bool, string, oneOfType } from 'prop-types';

export const Customer = shape({
  id: number,
  photo: string.isRequired,
  firstName: string.isRequired,
  middleName: string.isRequired,
  lastName: string.isRequired,
  isCompany: bool.isRequired,
  companyName: string,
  companyType: string,
  address: shape({
    customerAddressId: number,
    street: string.isRequired,
    street2: string,
    city: string.isRequired,
    state: string.isRequired,
    postal: string.isRequired
  })
});

export const savings = shape({
  monthly: oneOfType([string, number]),
  annual: oneOfType([string, number]),
  threeYear: oneOfType([string, number])
});

export const fuelSavings = shape({
  newMpg: oneOfType([string, number]),
  tradeMpg: oneOfType([string, number]),
  newPpg: oneOfType([string, number]),
  tradePpg: oneOfType([string, number]),
  necessaryDataIsProvidedToCalculateSavings: bool,
  savings
});



// WEBPACK FOOTER //
// ./src/propTypes/index.js